module.exports = __webpack_public_path__ + "fonts/o8GDU1Yf.woff";